import { render, staticRenderFns } from "./dialog-form.vue?vue&type=template&id=0a823b97&"
import script from "./dialog-form.vue?vue&type=script&lang=js&"
export * from "./dialog-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports